<!-- app/components/Alert.vue -->
<template>
  <div v-if="activeAlerts.length > 0"
       class="bg-white rounded-xl fixed top-20 lg:top-24 left-1/2 transform -translate-x-1/2 z-150
       flex flex-col gap-3 w-[90%] max-w-xl md:max-w-3xl">

      <TransitionGroup name="list">
          <UAlert v-for="alert in activeAlerts" :key="alert.id" :icon="alert.icone" :color="alert.tipo as any"
                  :title="alert.titulo" :description="alert.descricao" :close="alert.fechavel"
                  variant="subtle" class="p-2 shadow-lg border border-gray-200"
                  :ui="{ icon: 'size-8', title: 'text-lg', description: 'text-md' }">
            <template #close>
              <UButton title="Fechar" icon="ph:x" @click="uiStore.dispensarAlerta(alert.id)"
                       :color="alert.tipo as any" variant="ghost" />
            </template>
          </UAlert>
      </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

const uiStore = useUiStore()

// Utilizamos activeAlerts, que já vem filtrado por data, hora e fechamentos
const { activeAlerts } = storeToRefs(uiStore)
</script>

<style scoped>
/* Animações de entrada e saída dos alertas empilhados */
.list-enter-active, .list-leave-active {
  transition: all 0.3s ease;
}
.list-enter-from, .list-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>